const uri = process.env.API_REST_EXCEL_FILE;

export function getBulkUploadResultLogTxtFile(id) {
  let requestOptions = {
    method: "GET",
    redirect: "follow",
    headers: {
      "Content-Type": "application/json",
    },
  };
  
  return fetch(`${uri}/GetBulkUploadResultLog?` + new URLSearchParams({ bulkUploadBatchId: id }), requestOptions)
    .then((res) => {
      return res.blob();
    })
    .then((data) => {
      const a = document.createElement("a");
      a.href = window.URL.createObjectURL(data);
      a.download = "bulk-upload-result-log.txt";
      a.click();
    });
}
